/** Built with VITE_STAGING=1 (scripts/staging/deploy.sh, ADR-056): the staging copy of an app.
 * The badge keeps anyone from mistaking it for the live one; staging reaches no guests. */
export const STAGING = import.meta.env.VITE_STAGING === '1';

export function StagingBadge() {
  if (!STAGING) return null;
  return (
    <div className="pmh-staging-badge" role="note">
      Staging · test copy
    </div>
  );
}
